// extracted by mini-css-extract-plugin
module.exports = {"About":"Home_About__23Hza","image-appear":"Home_image-appear__3wqNm","h1-appear":"Home_h1-appear__Sa3iA","Develop":"Home_Develop__14M7t"};